export class UciRecordValidationError extends Error{
    constructor() {
        super("Bad UCI record");
    }
}